import useConfirm from "@/shared/atoms/useConfirm";
import { useSetModal } from "@/shared/atoms/useModal";
import { cn } from "@/shared/utils/cn";
import useOverlayAtom from "@/shared/atoms/useOverlayAtom";
interface Props {
  onClick?: any;
  className?: string;
}

const Overlay = ({ onClick, className }: Props) => {
  const setModal = useSetModal();
  const [confirmModal, setConfirmModal] = useConfirm();
  const [{ isOpen, closeOnClickOutside }, setOverlay] = useOverlayAtom();

  return (
    <div
      onClick={() => {
        if (closeOnClickOutside) {
          if (confirmModal) {
            setConfirmModal(null);
          } else {
            setModal("");
          }
          setOverlay((draft) => {
            draft.isOpen = false;
            draft.closeOnClickOutside = true;
          });
          onClick?.();
        }
      }}
      className={cn(
        "top-0 left-0 fixed z-1000 w-full h-full bg-text-secondary opacity-50",
        isOpen ? "block" : "hidden",
        className
      )}
    />
  );
};

export default Overlay;
